import React from 'react';
import Search from './Search';
import NotificationInfoTab from './notificationInfo/NotificationInfoTab';
import AuditInfoTab from './auditInfo/AuditInfoTab';
import { SetupPage } from 'areas/shared/pages/setup';
import * as Formatter from 'fw/components/formatter/Formatter';
import * as App from 'modules/app/App'
import * as API from 'modules/app/API'
import * as Help from 'modules/app/Help'

class NotificationSetup extends React.Component {
    render() {
        let opts = {
            title: "Notifications Setup",
            location: this.props.location,
            description: "Create and modify the Notification",
            addPrivilege: App.hasPrivilege("AdminNotificationSetupAdd"),
            addNewTitle: "Create New Notification",
            helpKey: Help.notificationSetupHelpKey,
            recentType: "notification",
            list: {
                url: API.App.url('/notificationSetup/search'),
                rowKey: "notificationId",
                columns: [
                    { key: 'description', name: 'Name', sortable: false },
                    { key: 'notificationTypeCode', name: 'Type', width: 200, sortable: true, cellClass: "text-center" },
                    { key: 'userTypeCode', name: 'Recipient', width: 200, sortable: true, cellClass: "text-center" },
                    { key: 'active', name: 'Active', formatter: Formatter.Check, width: 100, cellClass: "text-center" }
                ]
            },
            tabs: [
                { key: "notificationInfo", title: "Notification Info", comp: NotificationInfoTab, helpKey: Help.notificationSetupInfoHelpKey },
                { key: "auditInfo", title: "Audit Info", comp: AuditInfoTab, helpKey: Help.notificationSetupAuditHelpKey }
            ]
        }

        opts = Object.assign(opts, this.props);

        return (
            <SetupPage {...opts}
                Search={Search} />
        );
    }
}

export default NotificationSetup;



// WEBPACK FOOTER //
// ./src/areas/admin/notificationSetup/NotificationSetup.js